<template>
	<div
		class="c-splitpay"
		:class="[
			{
				'c-splitpay--disabled': !active,
			},
			'c-splitpay-current--' + current,
		]"
	>
		<div
			class="viabill-pricetag"
			data-dynamic-price=".ccf-price-splitpay-tag"
			data-view="product"
			data-currency="dkk"
			data-dynamic-price-triggers="button.cco-productVariants__variant"
		></div>

		<anyday-price-widget
			class="anyday-pricetag"
			size="small"
			theme="light"
			orientation="logo-right"
			currency="DKK"
			price-selector=".ccf-price-splitpay-tag"
			price-format-locale="da-DK"
			locale="da-DK"
			shop-name="Surisuri ApS"
			token="83c1a4e4af7543158401317fd0182125"
			fully-clickable="true"
			container-breakpoint="100"
			debug="info"
		>
		</anyday-price-widget>
	</div>
</template>

<script>
export default {
	name: "Splitpay",
	components: {},
	data: () => {
		return {
			current: 0,
		};
	},
	props: {
		active: Boolean,
	},

	methods: {
		isCurrent(index) {
			if (index == this.current) {
				return true;
			}

			return false;
		},
	},

	mounted() {
		setInterval(() => {
			if (this.current < 1) {
				this.current++;
			} else {
				this.current = 0;
			}
		}, 4000);
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-splitpay {
	position: relative;
	background-color: #fbf5f6;
	height: 42px;

	.viabill-pricetag {
		transition: $t-hover;
		opacity: 1;
		position: absolute;
		padding: 10px 0px 10px 0px;
		height: 42px !important;
		width: 100% !important;

		text-align: center;
	}

	.viabill {
		width: 260px !important;
	}

	.anyday-pricetag {
		transition: $t-hover;
		position: absolute;
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: nowrap;
		justify-content: center;
		white-space: nowrap;
	}

	.anyday-header {
		color: red !important;
	}

	.anyday-see-more-btn {
		display: none;
	}

	&-current {
		&--0 {
			.viabill-pricetag {
				pointer-events: none;
				opacity: 0;
			}
		}
		&--1 {
			.anyday-pricetag {
				pointer-events: none;
				opacity: 0;
			}
		}
	}

	&--disabled {
		display: none;
	}
}
</style>
